var _clipPath, _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    viewBox: "0 0 350 350"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-diamond",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.5 0, 0 0.5, 0.5 0.975, 0.99 0.5"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "174.5 3.5, 2.6 178.8, 174.5 345, 343 178.6"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwcHgiIHZpZXdCb3g9IjAgMCAzNTAgMzUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICA8Y2xpcFBhdGggaWQ9ImNsaXAtZGlhbW9uZCIgY2xpcFBhdGhVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgPHBvbHlnb24gcG9pbnRzPSIwLjUgMCwgMCAwLjUsIDAuNSAwLjk3NSwgMC45OSAwLjUiIC8+CiAgPC9jbGlwUGF0aD4KICA8cG9seWdvbiBwb2ludHM9IjE3NC41IDMuNSwgMi42IDE3OC44LCAxNzQuNSAzNDUsIDM0MyAxNzguNiIvPgo8L3N2Zz4K";
export { SvgDiamond as ReactComponent };